<template>
<v-card tile class="elevation-10 ma-sm-2" >
  <v-card-title class='subtitle-1 overline justify-center py-0 grey darken-4 white--text pr-0' >
    Add a new space
    <!-- <v-btn @click='get' /> -->
    <v-spacer/>
    <!-- <v-btn small flat dark @click='step++' >
      Next
      <v-icon small >mdi-arrow-right</v-icon>
    </v-btn> -->
  </v-card-title>
    <request-status :request='req.space' />
    <request-status :request='req.settings' />
    <v-window v-model="step" vertical >
      <!-- <v-window-item >

          <v-text-field filled autofocus persistent-hint
            v-model='spaceTitle'
            label='What is the name of your business?'
            :hint='businessNameHint'
            append-icon='mdi-arrow-right'
            @keypress.enter="savespace(true)"
            @click:append='savespace(true)' />

          <card-actions
            :with-back='false'
            :with-skip='false'
            :next-loading='req.space.loading'
            @next='savespace(true)' />

      </v-window-item > -->

      <v-window-item v-if="isMedical" >
        <!-- {{spaceId}} | {{spaceSettingsId}} | {{settingsPracticeNumber}} -->
        <v-text-field filled autofocus
          v-model='spaceSettings.practice_number'
          label='Do you have a practice number?'
          append-icon='mdi-arrow-right'
          @keypress.enter="saveSetting('practice_number', spaceSettings.practice_number, true)"
          @click:append="saveSetting('practice_number', spaceSettings.practice_number, true)" />

        <card-actions
            :next-loading='req.space.loading'
            @back='step--'
            @skip='step++'
            @next="saveSetting('practice_number', spaceSettings.practice_number, true)" />

      </v-window-item>

      <v-window-item >
        <!-- {{spaceId}} | {{spaceSettingsId}} | {{settingsPracticeNumber}} -->
        <v-subheader class='overline' >Your billing address</v-subheader>
        <v-textarea filled autofocus persistent-hint
          v-model='spaceSettings.billing_address'
          label='Your billing address'
          hint="This will be added to the invoices that you generate for your clients"
          append-icon='mdi-arrow-right'
          @click:append="saveSetting('billing_address', spaceSettings.billing_address, true)" />

        <card-actions
            :next-loading='req.space.loading'
            @back='step--'
            @skip='step++'
            @next="saveSetting('billing_address', spaceSettings.billing_address, true)" />

      </v-window-item>

      <v-window-item >
        <!-- {{spaceId}} | {{spaceSettingsId}} | {{settingsPracticeNumber}} -->
        <v-subheader class='overline' >Your banking details</v-subheader>
        <v-textarea filled autofocus persistent-hint
          v-model='spaceSettings.banking_details'
          label='Your banking details'
          hint="These will be added to the invoices that you generate for your clients"
          append-icon='mdi-arrow-right'
          @click:append="saveSetting('banking_details', spaceSettings.banking_details, true)" />

        <card-actions
            :next-loading='req.space.loading'
            @back='step--'
            @skip='step++'
            @next="saveSetting('banking_details', spaceSettings.banking_details, true)" />

      </v-window-item>

      <v-window-item >
        <v-card :elevation='10' >
          <v-card-title class='subtitle-1 overline justify-center' >
            Add a logo
          </v-card-title>

          <uploader flat avatarTile
            v-model='spaceSettings.logo_picture'
            filename='logo_picture'
            :upload-path = "`/api/v3/spaces/${spaceId}/settings/${spaceSettingsId}/`"
            @input='step++'
            @uploadfailure='pictureUploadError=true' />


          <card-actions :with-next='false'
            @back='step--'
            @skip='step++' />

          <!-- <v-card-actions >
            <v-btn @click='step--' text >Back</v-btn>
            <v-spacer/>
            <v-btn @click="step++" small text >Skip this step</v-btn>
            <v-btn color='primary' >Next</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-window-item>

      <v-window-item >
        <locations chips
          v-if="spaceId"
          :space-id="spaceId"
          @back='step--'
          @next='step++;init()' />
      </v-window-item>

      <v-window-item >
        <appointment-types
          v-if="spaceId"
          :space-id="spaceId"
          v-model='products'
          @back='step--'
          @next='wizardComplete' />
      </v-window-item>

      <!-- <v-window-item >
        <space-card v-model='space' >
          <v-card-actions slot='card-actions' class='mt-10' >
            <v-spacer />
            <v-btn @click='$emit("done")' large color="primary" >Next</v-btn>
          </v-card-actions>
        </space-card>

      </v-window-item> -->

    </v-window>

    <!-- <pre v-text="spaceSettings" /> -->

</v-card>
</template>
<script>
import AppointmentTypes from './AppointmentTypes.vue'
import Locations from './Locations.vue'
import CardActions from './CardActions.vue'
import Uploader from '@/components/ui/Uploader.vue'
// import SpaceCard from '@/components/SpaceCard.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'Space',
  components: { AppointmentTypes, Uploader, Locations, CardActions },
  props: {
    value: { type: Object },
    user: { type: Object }
  },
  data () {
    return {
      space: {},
      spaceSettings: {},
      step: 0,
      advance: false,
      pictureUploadError: false,
      req: {
        space: {
          resource: 'ag.spaces'
        },
        settings: {
          resource: 'ag.spaces',
          extra: 'settings'
        },
        addresses: {
          resource: 'ag.spaces',
          extra: 'addresses'
        }
      },
      locations: [],
      products: []
    }
  },
  mounted () {
    this.get()
    this.$emit('progress', 0)
  },
  methods: {
    get () {
      this.req.space.resourceId = this.spaceId
      this.$request('get', this.req.space)
    },
    savespace (advance) {
      if (this.spaceId) {
        this.req.space.resourceId = this.spaceId
        this.req.space.data = {
          title: this.spaceTitle
        }
        this.$request('save', this.req.space)

        this.advance = false
        if (advance === true) { this.advance = true }
      }
    },
    saveSetting (key, value, advance) {
      this.req.settings.data = {}
      this.req.settings.data[key] = value
      this.req.settings.resourceId = this.spaceId
      this.req.settings.extra = 'settings/' + this.spaceSettingsId
      this.$request('save', this.req.settings)

      this.advance = false
      if (advance === true) { this.advance = true }
    },
    wizardComplete () {
      this.$emit("done", this.space)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.space = this.value
      }
    },
    spaceReqStatus () {
      if (this.spaceReqStatus === 200) {
        if (this.req.space.resourceId) {
          this.space = this.req.space.result
        } else {
          let res = this.getObjectPath(this.req.space, 'result.results', [])
          if (res.length > 0) {
            this.space = this.req.space.result.results[0]
          }
        }
        this.spaceSettings = this.getObjectPath(this.space, 'settings', {})
        if (this.advance === true) { this.step++ }
      }
    },
    settingsReqStatus () {
      if (this.settingsReqStatus === 200) {
        let settings = this.req.space.result
        this.$store.commit('setSpaceSettings', settings)
        if (this.advance === true) { this.step++ }
      }
    },
    wizProgress () {
      this.$emit('progress', this.wizProgress)
    }
  },
  computed: {
    ...mapGetters(['me', 'meProfile']),
    spaceId () { return this.getObjectPath(this.space, 'id') },
    spaceSettingsId () { return this.getObjectPath(this.space, 'settings.id') },
    spaceReqStatus () { return this.req.space.status },
    settingsReqStatus () { return this.req.settings.status },
    businessNameHint () {
      // profession from global.js mixin
      if (this.professionName && this.spaceTitle) {
        return `e.g.: ${this.spaceTitle}, ${this.professionName}`
      }
      return 'e.g.: Johan Bloem, Biokineticist'
    },
    professionName () { return this.getObjectPath(this.profession, 'name') },
    isMedical () { return this.getObjectPath(this.profession, 'is_medical', true) },
    wizProgress () {
      let steps = 7
      if (this.step > 0) {
        return Math.round(this.step / steps * 100)
      }
      return 0
    }
  }
}
</script>
